import { createAction, props } from '@ngrx/store';

export const loadAction_start = createAction('loadAction_start', props<{ actionType: string }>());
export const loadAction_stop = createAction('loadAction_stop', props<{ actionType: string }>());
